module.exports = __webpack_public_path__ + "static/media/briansusandad.94b83751.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/briansusandad.jpg
// module id = 580
// module chunks = 0